// Client layer (TS-2.5.03). The read-only note list the sixth stat card's click opens
// (decisions.md D-285/D-286): unlike D-284's `StatCardMembersModal` (one row per member PROJECT
// KEY), this card's membership (`StatCardValue.memberNoteKeys`) names NOTES, so this is a
// different modal rather than a second mode bolted onto the first - the row shape (type badge,
// note text, project link, status, date) has nothing in common with a project row. Notes are
// resolved, never re-derived: `notesByKey` is built once from the SAME `ProjectView.risks` every
// project already carries (`lib/riskNotes.ts`), mirroring D-284's resolve-don't-re-derive rule one
// level down. A note key the current view's project data does not carry is named as a count
// rather than dropped, exactly as D-284 does for a missing project key.
import { Link } from "react-router-dom";
import { Modal } from "../../components/Modal";
import { RiskTypeBadge } from "./RiskTypeBadge";
import type { RiskItem, StatCardValue } from "../../api/generated/contracts";
import { strings } from "../../strings";

const S = strings.roadmap.notesCardModal;

export interface StatCardNotesModalProps {
  readonly open: boolean;
  readonly card: StatCardValue;
  readonly notesByKey: ReadonlyMap<string, RiskItem>;
  readonly onClose: () => void;
}

export function StatCardNotesModal({ open, card, notesByKey, onClose }: StatCardNotesModalProps) {
  const resolved: RiskItem[] = [];
  for (const key of card.memberNoteKeys) {
    const note = notesByKey.get(key);
    if (note) resolved.push(note);
  }
  const missingCount = card.memberNoteKeys.length - resolved.length;

  return (
    <Modal open={open} title={card.label} onClose={onClose} closeLabel={strings.roadmap.statCardModal.close}>
      {card.memberProjectKeys.length > 0 && (
        <p className="eg-stat-card-modal__meta">{S.acrossProjects(card.memberProjectKeys.length)}</p>
      )}

      {resolved.length > 0 ? (
        <ul className="eg-stat-card-modal__list">
          {resolved.map((note) => (
            <li key={note.key} className="eg-stat-card-modal__item">
              <RiskTypeBadge note={note} />
              <span className="eg-stat-card-modal__note-text">{note.text}</span>
              <Link to={`/projects/${note.projectKey}`} className="eg-stat-card-modal__name">
                {note.projectName}
              </Link>
              <span className="eg-stat-card-modal__meta">{note.statusLabel}</span>
              <span className="eg-stat-card-modal__meta">
                {note.noteDate ? new Date(note.noteDate).toLocaleDateString() : "—"}
              </span>
            </li>
          ))}
        </ul>
      ) : null}

      {missingCount > 0 && <p className="eg-stat-card-modal__missing">{S.missingNotes(missingCount)}</p>}
    </Modal>
  );
}
